// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectGoogleAuthConfirmResponseMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_CONFIRM_2FA_RESPONSE);
        this.Success = null;
    }
}
